import styled from 'styled-components';

export const TagList = styled.ul`
  list-style: none;
  padding: 0;

  li {
    display: inline-block;
    padding: 0.8em;
    border-radius: 9999px;
    margin: 0 8px 8px 0;
    font-weight: 500;
    font-size: 0.75rem;
    line-height: 1.4;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    border: 1px solid #d9d9d9;
  }
`;
